import { createActions, createReducer } from "reduxsauce";
import { onChangeFieldValue } from "utils/functions";
import { defaultState } from "./attendance-model";

export const { Types, Creators } = createActions({
  attendanceShowLoading: [],
  attendanceHideLoading: [],
  attendanceShowLoadingTable: [],
  attendanceHideLoadingTable: [],
  attendanceShowLoadingSummary: [],
  attendanceHideLoadingSummary: [],
  attendanceHideDrawerVehicleEntryAuthorization: [],
  attendanceShowDrawerVehicleEntryAuthorization: [],
  attendanceDisabledButtonReleaseVehicle: [],
  attendanceEnabledButtonReleaseVehicle: [],
  attendanceDisabledButtonSaveVehicle: [],
  attendanceEnabledButtonSaveVehicle: [],
  attendanceShowModalVehicleAction: [],
  attendanceHideModalVehicleAction: [],
  attendanceShowDrawerViewCheckinRegister: [],
  attendanceHideDrawerViewCheckinRegister: [],
  attendanceShowDrawerCheckinRegister: [],
  attendanceHideDrawerCheckinRegister: [],
  attendanceShowDrawerViewRegister: [],
  attendanceHideDrawerViewRegister: [],
  attendanceEnableExcludeButton: [],
  attendanceDisableExcludeButton: [],
  attendanceShowModalReleaseVehicleAction: [],
  attendanceHideModalReleaseVehicleAction: [],
  attendanceEnabledRegisterButton: [],
  attendanceDisabledRegisterButton: [],
  attendanceVehicleStatusList: ["vehicleStatusList"],
  attendanceUpdateDrawerViewMode: ["visibleDrawerViewMode"],
  attendanceUpdateFormModified: ["formViewOrEditModified"],
  attendanceUpdateFilterTable: ["searchFilter"],
  attendanceChangeFieldValue: ["fieldName", "value"],
  attendanceChangeFilterOptionsValue: ["filterOptions", "value"],
  attendanceFetchRegister: ["items", "totalItems"],
  attendanceUpdateVehicleEntryAuthorizationRegisterActive: ["vehicleEntryAuthorizationRegisterActive"],
  attendanceUpdateActiveSummary: ["activeSummaryData"],
  attendanceUpdateTabpaneActive: ["tabPaneActive"],
  attendanceUpdateItemsCheckin: ["itemsCheckin"],
  attendanceFetchRegisterAsync: [],
  attendanceSaveVehicleActionAsync: ["body"],
  attendanceFetchItemsCheckinAsync: ["body"],
  attendanceSaveReleaseVehicleActionAsync: ["body"],
  attendanceSaveCheckinRegisterAsync: ["body"],
  attendanceRemoveCheckinRegisterAsync: ["body"],
  attendanceUpdateInboundAsync: ["body"],
  attendanceUpdateCheckinAsync: ["body"],
  attendanceFetchItemVehicleEntryAuthorizationAsync: ["body"],
  attendanceFetchSummaryAsync: [],
  attendanceFetchVehicleStatusAsync: [],
});

export const showLoading = (state = defaultState) => ({
  ...state,
  isLoading: true,
});

export const hideLoading = (state = defaultState) => ({
  ...state,
  isLoading: false,
});

export const showLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: true,
});

export const hideLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: false,
});

export const showLoadingSummary = (state = defaultState) => ({
  ...state,
  isLoadingSummary: true,
});

export const hideLoadingSummary = (state = defaultState) => ({
  ...state,
  isLoadingSummary: false,
});

export const disabledButtonReleaseVehicle = (state = defaultState) => ({
  ...state,
  disabledButtonReleaseVehicle: true,
});

export const enabledButtonReleaseVehicle = (state = defaultState) => ({
  ...state,
  disabledButtonReleaseVehicle: false,
});

export const disabledButtonSaveVehicle = (state = defaultState) => ({
  ...state,
  disabledButtonSaveVehicle: true,
});

export const enabledButtonSaveVehicle = (state = defaultState) => ({
  ...state,
  disabledButtonSaveVehicle: false,
});

export const showDrawerViewCheckinRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerViewCheckinRegisterAttendance: true,
});

export const hideDrawerViewCheckinRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerViewCheckinRegisterAttendance: false,
});

export const showDrawerViewRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerViewRegisterAttendance: true,
});

export const hideDrawerViewRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerViewRegisterAttendance: false,
});

export const enableExcludeButton = (state = defaultState) => ({
  ...state,
  excludeButtonDisabled: false,
});

export const disableExcludeButton = (state = defaultState) => ({
  ...state,
  excludeButtonDisabled: true,
});

export const updateDrawerViewMode = (state, action) => ({
  ...state,
  visibleDrawerViewMode: action.visibleDrawerViewMode,
});

export const updatformViewOrEditModified = (state, action) => ({
  ...state,
  formViewOrEditModified: action.formViewOrEditModified,
});

export const updateTabPaneActive = (state, action) => ({
  ...state,
  tabPaneActive: action.tabPaneActive,
});

export const showDrawerCheckinRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerCheckinRegisterAttendance: true,
});

export const hideDrawerCheckinRegister = (state = defaultState) => ({
  ...state,
  visibleDrawerCheckinRegisterAttendance: false,
});

export const showModalVehicleAction = (state = defaultState) => ({
  ...state,
  visibleModalVehicleAction: true,
});

export const hideModalVehicleAction = (state = defaultState) => ({
  ...state,
  visibleModalVehicleAction: false,
});

export const showDrawerVehicleEntryAuthorization = (state = defaultState) => ({
  ...state,
  visibleDrawerVehicleEntryAuthorization: true,
});

export const hideDrawerVehicleEntryAuthorization = (state = defaultState) => ({
  ...state,
  visibleDrawerVehicleEntryAuthorization: false,
});

export const disabledRegisterButton = (state = defaultState) => ({
  ...state,
  disabledButton: true,
});

export const enableRegisterButton = (state = defaultState) => ({
  ...state,
  disabledButton: false,
});

export const fetchAttendance = (state, { items, totalItems }) => ({
  ...state,
  isLoading: false,
  items,
  totalItems,
});

export const changeFieldValue = (state, { fieldName, value }) => ({
  ...state,
  filter: onChangeFieldValue(state.filter, fieldName, value),
});

export const showModalReleaseVehicleAction = (state = defaultState) => ({
  ...state,
  visibleModalReleaseVehicle: true,
});

export const hideModalReleaseVehicleAction = (state = defaultState) => ({
  ...state,
  visibleModalReleaseVehicle: false,
});

export const updateFilterTable = (state, action) => {
  return {
    ...state,
    searchFilter: action.searchFilter,
  };
};

export const updateVehicleEntryAuthorizationRegisterActive = (state, { vehicleEntryAuthorizationRegisterActive }) => ({
  ...state,
  vehicleEntryAuthorizationRegisterActive,
});

export const updateActiveSummary = (state, { activeSummaryData }) => ({
  ...state,
  activeSummaryData,
});

export const changeFilterOptionsValue = (state, { filterOptions, value }) => ({
  ...state,
  filterOptions: onChangeFieldValue(state.filterOptions, filterOptions, value),
});

export const setVehicleStatusList = (state, { vehicleStatusList }) => ({
  ...state,
  ...vehicleStatusList,
});

export const updateItemsCheckin = (state, { itemsCheckin }) => ({
  ...state,
  itemsCheckin,
});

export default createReducer(defaultState, {
  [Types.ATTENDANCE_SHOW_LOADING]: showLoading,
  [Types.ATTENDANCE_HIDE_LOADING]: hideLoading,
  [Types.ATTENDANCE_SHOW_LOADING_TABLE]: showLoadingTable,
  [Types.ATTENDANCE_HIDE_LOADING_TABLE]: hideLoadingTable,
  [Types.ATTENDANCE_SHOW_LOADING_SUMMARY]: showLoadingSummary,
  [Types.ATTENDANCE_HIDE_LOADING_SUMMARY]: hideLoadingSummary,
  [Types.ATTENDANCE_DISABLED_BUTTON_RELEASE_VEHICLE]: disabledButtonReleaseVehicle,
  [Types.ATTENDANCE_ENABLED_BUTTON_RELEASE_VEHICLE]: enabledButtonReleaseVehicle,
  [Types.ATTENDANCE_DISABLED_BUTTON_SAVE_VEHICLE]: disabledButtonSaveVehicle,
  [Types.ATTENDANCE_ENABLED_BUTTON_SAVE_VEHICLE]: enabledButtonSaveVehicle,
  [Types.ATTENDANCE_SHOW_DRAWER_VIEW_CHECKIN_REGISTER]: showDrawerViewCheckinRegister,
  [Types.ATTENDANCE_HIDE_DRAWER_VIEW_CHECKIN_REGISTER]: hideDrawerViewCheckinRegister,
  [Types.ATTENDANCE_SHOW_DRAWER_VEHICLE_ENTRY_AUTHORIZATION]: showDrawerVehicleEntryAuthorization,
  [Types.ATTENDANCE_HIDE_DRAWER_VEHICLE_ENTRY_AUTHORIZATION]: hideDrawerVehicleEntryAuthorization,
  [Types.ATTENDANCE_UPDATE_DRAWER_VIEW_MODE]: updateDrawerViewMode,
  [Types.ATTENDANCE_UPDATE_FORM_MODIFIED]: updatformViewOrEditModified,
  [Types.ATTENDANCE_UPDATE_TABPANE_ACTIVE]: updateTabPaneActive,
  [Types.ATTENDANCE_DISABLED_REGISTER_BUTTON]: disabledRegisterButton,
  [Types.ATTENDANCE_ENABLED_REGISTER_BUTTON]: enableRegisterButton,
  [Types.ATTENDANCE_SHOW_DRAWER_CHECKIN_REGISTER]: showDrawerCheckinRegister,
  [Types.ATTENDANCE_HIDE_DRAWER_CHECKIN_REGISTER]: hideDrawerCheckinRegister,
  [Types.ATTENDANCE_SHOW_DRAWER_VIEW_REGISTER]: showDrawerViewRegister,
  [Types.ATTENDANCE_HIDE_DRAWER_VIEW_REGISTER]: hideDrawerViewRegister,
  [Types.ATTENDANCE_SHOW_MODAL_VEHICLE_ACTION]: showModalVehicleAction,
  [Types.ATTENDANCE_HIDE_MODAL_VEHICLE_ACTION]: hideModalVehicleAction,
  [Types.ATTENDANCE_SHOW_MODAL_RELEASE_VEHICLE_ACTION]: showModalReleaseVehicleAction,
  [Types.ATTENDANCE_HIDE_MODAL_RELEASE_VEHICLE_ACTION]: hideModalReleaseVehicleAction,
  [Types.ATTENDANCE_FETCH_REGISTER]: fetchAttendance,
  [Types.ATTENDANCE_CHANGE_FIELD_VALUE]: changeFieldValue,
  [Types.ATTENDANCE_UPDATE_FILTER_TABLE]: updateFilterTable,
  [Types.ATTENDANCE_ENABLE_EXCLUDE_BUTTON]: enableExcludeButton,
  [Types.ATTENDANCE_DISABLE_EXCLUDE_BUTTON]: disableExcludeButton,
  [Types.ATTENDANCE_UPDATE_VEHICLE_ENTRY_AUTHORIZATION_REGISTER_ACTIVE]: updateVehicleEntryAuthorizationRegisterActive,
  [Types.ATTENDANCE_UPDATE_ACTIVE_SUMMARY]: updateActiveSummary,
  [Types.ATTENDANCE_CHANGE_FILTER_OPTIONS_VALUE]: changeFilterOptionsValue,
  [Types.ATTENDANCE_VEHICLE_STATUS_LIST]: setVehicleStatusList,
  [Types.ATTENDANCE_UPDATE_ITEMS_CHECKIN]: updateItemsCheckin,
});
